"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.snapToClosestScreenWidth = snapToClosestScreenWidth;
exports.snapWidthToScreenWidthIfSmallScreen = snapWidthToScreenWidthIfSmallScreen;
exports.getProportionalHeight = getProportionalHeight;
exports.getProportionalWidth = getProportionalWidth;
exports.adjustSizeByPixelRatio = adjustSizeByPixelRatio;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var WIDTHS_MOBILE = [320, 375, 425, 768, 1024];
var SMALL_SCREEN_THRESHOLD = 1024;

function snapToClosestScreenWidth(w) {
  return WIDTHS_MOBILE.reduce(function (closest, v) {
    var d1 = v - w;
    var d2 = closest - w;

    return Math.abs(d1) < Math.abs(d2) ? d1 >= 0 || d2 < 0 ? v : closest : closest;
  });
}

function snapWidthToScreenWidthIfSmallScreen(fn) {
  return function (_ref) {
    var w = _ref.w,
        sW = _ref.sW,
        params = _objectWithoutProperties(_ref, ["w", "sW"]);

    var newWidth = sW < SMALL_SCREEN_THRESHOLD && (!w || w > sW) ? snapToClosestScreenWidth(sW) : w;
    return fn(_extends({ w: newWidth, sW: sW }, params));
  };
}

function getProportionalHeight(originalWidth, originalHeight, w) {
  return w / (originalWidth / originalHeight);
}
function getProportionalWidth(originalWidth, originalHeight, h) {
  return h * (originalWidth / originalHeight);
}

// eslint-disable-next-line max-params
function adjustSizeByPixelRatio(originalWidth, originalHeight, w, h, pixelRatio) {
  var nW = Math.ceil(w * pixelRatio);
  var nH = Math.ceil(h * pixelRatio);
  var isLargerThanOrig = nW > originalWidth || nH > originalHeight;

  return {
    width: isLargerThanOrig ? originalWidth : nW,
    height: isLargerThanOrig ? originalHeight : nH
  };
}